export enum GermanCountryNames {
  AF = 'Afghanistan',
  AX = 'Åland-Inseln',
  AL = 'Albanien',
  DZ = 'Algerien',
  AS = 'Amerikanisch-Samoa',
  AD = 'Andorra',
  AO = 'Angola',
  AI = 'Anguilla',
  AQ = 'Antarktis',
  AG = 'Antigua und Barbuda',
  AR = 'Argentinien',
  AM = 'Armenien',
  AW = 'Aruba',
  AU = 'Australien',
  AT = 'Österreich',
  AZ = 'Aserbaidschan',
  BS = 'Bahamas',
  BH = 'Bahrain',
  BD = 'Bangladesch',
  BB = 'Barbados',
  BY = 'Belarus',
  BE = 'Belgien',
  BZ = 'Belize',
  BJ = 'Benin',
  BM = 'Bermuda',
  BT = 'Bhutan',
  BO = 'Bolivien',
  BQ = 'Bonaire, Sint Eustatius und Saba',
  BA = 'Bosnien und Herzegowina',
  BW = 'Botswana',
  BV = 'Bouvet Insel',
  BR = 'Brasilien',
  IO = 'Britisches Territorium Im Indischen Ozean',
  BN = 'Brunei Darussalam',
  BG = 'Bulgarien',
  BF = 'Burkina Faso',
  BI = 'Burundi',
  CV = 'Cabo Verde',
  KH = 'Kambodscha',
  CM = 'Kamerun',
  CA = 'Kanada',
  KY = 'Cayman-Inseln',
  CF = 'Zentralafrikanische Republik',
  TD = 'Tschad',
  CL = 'Chile',
  CN = 'China',
  CX = 'Christmas Island',
  CC = 'Cocos (Keeling) Inseln',
  CO = 'Kolumbien',
  KM = 'Komoren',
  CG = 'Kongo',
  CD = 'Demokratische Republik Kongo',
  CK = 'Cook-Inseln',
  CR = 'Costa Rica',
  CI = 'Elfenbeinküste',
  HR = 'Kroatien',
  CU = 'Kuba',
  CW = 'Curaçao',
  CY = 'Zypern',
  CZ = 'Tschechien',
  DK = 'Dänemark',
  DJ = 'Dschibuti',
  DM = 'Dominica',
  DO = 'Dominikanische Republik',
  EC = 'Ecuador',
  EG = 'Ägypten',
  SV = 'El Salvador',
  GQ = 'Äquatorial-Guinea',
  ER = 'Eritrea',
  EE = 'Estland',
  ET = 'Äthiopien',
  FK = 'Falkland-Inseln',
  FO = 'Färöer-Inseln',
  FJ = 'Fidschi',
  FI = 'Finnland',
  FR = 'Frankreich',
  GF = 'Französisch-Guayana',
  PF = 'Französisch-Polynesien',
  TF = 'Französische Süd-Und Antarktisgebiete',
  GA = 'Gabun',
  GM = 'Gambia',
  GE = 'Georgien',
  DE = 'Deutschland',
  GH = 'Ghana',
  GI = 'Gibraltar',
  GR = 'Griechenland',
  GL = 'Grönland',
  GD = 'Grenada',
  GP = 'Guadeloupe',
  GU = 'Guam',
  GT = 'Guatemala',
  GG = 'Guernsey',
  GN = 'Guinea',
  GW = 'Guinea-Bissau',
  GY = 'Guyana',
  HT = 'Haiti',
  HM = 'Heard Insel und McDonald Inseln',
  VA = 'Vatikanstadt',
  HN = 'Honduras',
  HK = 'Hong Kong',
  HU = 'Ungarn',
  IS = 'Island',
  IN = 'Indien',
  ID = 'Indonesien',
  IR = 'Iran',
  IQ = 'Irak',
  IE = 'Irland',
  IM = 'Isle of Man',
  IL = 'Israel',
  IT = 'Italien',
  JM = 'Jamaika',
  JP = 'Japan',
  JE = 'Jersey',
  JO = 'Jordan',
  KZ = 'Kasachstan',
  KE = 'Kenia',
  KI = 'Kiribati',
  KP = 'Nordkorea',
  KR = 'Südkorea',
  KW = 'Kuwait',
  KG = 'Kirgistan',
  LA = 'Leos',
  LV = 'Lettland',
  LB = 'Libanon',
  LS = 'Lesotho',
  LR = 'Liberia',
  LY = 'Libyen',
  LI = 'Liechtenstein',
  LT = 'Litauen',
  LU = 'Luxemburg',
  MO = 'Macao',
  MK = 'Mazedonien',
  MG = 'Madagaskar',
  MW = 'Malawi',
  MY = 'Malaysia',
  MV = 'Malediven',
  ML = 'Mali',
  MT = 'Malta',
  MH = 'Marshall-Inseln',
  MQ = 'Martinique',
  MR = 'Mauretanien',
  MU = 'Mauritius',
  YT = 'Mayotte',
  MX = 'Mexiko',
  FM = 'Mikronesien',
  MD = 'Moldau',
  MC = 'Monaco',
  MN = 'Mongolei',
  ME = 'Montenegro',
  MS = 'Montserrat',
  MA = 'Marokko',
  MZ = 'Mosambik',
  MM = 'Myanmar',
  NA = 'Namibia',
  NR = 'Nauru',
  NP = 'Nepal',
  NL = 'Niederlande',
  NC = 'Neukaledonien',
  NZ = 'Neuseeland',
  NI = 'Nicaragua',
  NE = 'Niger',
  NG = 'Nigeria',
  NU = 'Niue',
  NF = 'Norfolk Island',
  MP = 'Nord-Mariana Inseln',
  NO = 'Norwegen',
  OM = 'Oman',
  PK = 'Pakistan',
  PW = 'Palau',
  PS = 'Palästina',
  PA = 'Panama',
  PG = 'Papua-Neuguinea',
  PY = 'Paraguay',
  PE = 'Peru',
  PH = 'Philippinen',
  PN = 'Pitcairn',
  PL = 'Polen',
  PT = 'Portugal',
  PR = 'Puerto Rico',
  QA = 'Katar',
  RE = 'Réunion',
  RO = 'Rumänien',
  RU = 'Russische Föderation',
  RW = 'Ruanda',
  BL = 'Saint-Barthélemy',
  SH = 'St. Helena, Ascension und Tristan da Cunha',
  KN = 'Saint Kitts und Nevis',
  LC = 'Saint Lucia',
  MF = 'Saint Martin',
  PM = 'Saint Pierre und Miquelon',
  VC = 'Saint Vincent und die Grenadinen',
  WS = 'Samoa',
  SM = 'San Marino',
  ST = 'Sao Tome und Principe',
  SA = 'Saudi-Arabien',
  SN = 'Senegal',
  RS = 'Serbien',
  SC = 'Seychellen',
  SL = 'Sierra Leone',
  SG = 'Singapur',
  SX = 'Sint Maarten',
  SK = 'Slowakei',
  SI = 'Slowenien',
  SB = 'Salomon-Inseln',
  SO = 'Somalia',
  ZA = 'Südafrika',
  GS = 'South Georgia und die South Sandwich Inseln',
  SS = 'Süd-Sudan',
  ES = 'Spanien',
  LK = 'Sri Lanka',
  SD = 'Sudan',
  SR = 'Suriname',
  SJ = 'Svalbard und Jan Mayen',
  SZ = 'Swasiland',
  SE = 'Schweden',
  CH = 'Schweiz',
  SY = 'Syrien',
  TW = 'Taiwan',
  TJ = 'Tadschikistan',
  TZ = 'Tansania',
  TH = 'Thailand',
  TL = 'Timor-Leste',
  TG = 'Togo',
  TK = 'Tokelau',
  TO = 'Tonga',
  TT = 'Trinidad und Tobago',
  TN = 'Tunesien',
  TR = 'Türkei',
  TM = 'Turkmenistan',
  TC = 'Turks-und Caicos-Inseln',
  TV = 'Tuvalu',
  UG = 'Uganda',
  UA = 'Ukraine',
  AE = 'Vereinigte Arabische Emirate',
  GB = 'Vereinigtes Königreich von Großbritannien und Nordirland',
  US = 'Vereinigte Staaten von Amerika',
  UM = 'United States Minor Outlying Islands',
  UY = 'Uruguay',
  UZ = 'Usbekistan',
  VU = 'Vanuatu',
  VE = 'Venezuela',
  VN = 'Vietnam',
  VG = 'Virgin Islands (British)',
  VI = 'Virgin Islands (US)',
  WF = 'Wallis und Futuna',
  EH = 'Western Sahara',
  YE = 'Jemen',
  ZM = 'Sambia',
  ZW = 'Simbabwe',
}

export const GermanToCountryCode = {
  'Afghanistan': 'AF',
  'Åland-Inseln': 'AX',
  'Albanien': 'AL',
  'Algerien': 'DZ',
  'Amerikanisch-Samoa': 'AS',
  'Andorra': 'AD',
  'Angola': 'AO',
  'Anguilla': 'AI',
  'Antarktis': 'AQ',
  'Antigua und Barbuda': 'AG',
  'Argentinien': 'AR',
  'Armenien': 'AM',
  'Aruba': 'AW',
  'Australien': 'AU',
  'Österreich': 'AT',
  'Aserbaidschan': 'AZ',
  'Bahamas': 'BS',
  'Bahrain': 'BH',
  'Bangladesch': 'BD',
  'Barbados': 'BB',
  'Belarus': 'BY',
  'Belgien': 'BE',
  'Belize': 'BZ',
  'Benin': 'BJ',
  'Bermuda': 'BM',
  'Bhutan': 'BT',
  'Bolivien': 'BO',
  'Bonaire, Sint Eustatius und Saba': 'BQ',
  'Bosnien und Herzegowina': 'BA',
  'Botswana': 'BW',
  'Bouvet Insel': 'BV',
  'Brasilien': 'BR',
  'Britisches Territorium Im Indischen Ozean': 'IO',
  'Brunei Darussalam': 'BN',
  'Bulgarien': 'BG',
  'Burkina Faso': 'BF',
  'Burundi': 'BI',
  'Cabo Verde': 'CV',
  'Kambodscha': 'KH',
  'Kamerun': 'CM',
  'Kanada': 'CA',
  'Cayman-Inseln': 'KY',
  'Zentralafrikanische Republik': 'CF',
  'Tschad': 'TD',
  'Chile': 'CL',
  'China': 'CN',
  'Christmas Island': 'CX',
  'Cocos (Keeling) Inseln': 'CC',
  'Kolumbien': 'CO',
  'Komoren': 'KM',
  'Kongo': 'CG',
  'Demokratische Republik Kongo': 'CD',
  'Cook-Inseln': 'CK',
  'Costa Rica': 'CR',
  'Elfenbeinküste': 'CI',
  'Kroatien': 'HR',
  'Kuba': 'CU',
  'Curaçao': 'CW',
  'Zypern': 'CY',
  'Tschechien': 'CZ',
  'Dänemark': 'DK',
  'Dschibuti': 'DJ',
  'Dominica': 'DM',
  'Dominikanische Republik': 'DO',
  'Ecuador': 'EC',
  'Ägypten': 'EG',
  'El Salvador': 'SV',
  'Äquatorial-Guinea': 'GQ',
  'Eritrea': 'ER',
  'Estland': 'EE',
  'Äthiopien': 'ET',
  'Falkland-Inseln': 'FK',
  'Färöer-Inseln': 'FO',
  'Fidschi': 'FJ',
  'Finnland': 'FI',
  'Frankreich': 'FR',
  'Französisch-Guayana': 'GF',
  'Französisch-Polynesien': 'PF',
  'Französische Süd-Und Antarktisgebiete': 'TF',
  'Gabun': 'GA',
  'Gambia': 'GM',
  'Georgien': 'GE',
  'Deutschland': 'DE',
  'Ghana': 'GH',
  'Gibraltar': 'GI',
  'Griechenland': 'GR',
  'Grönland': 'GL',
  'Grenada': 'GD',
  'Guadeloupe': 'GP',
  'Guam': 'GU',
  'Guatemala': 'GT',
  'Guernsey': 'GG',
  'Guinea': 'GN',
  'Guinea-Bissau': 'GW',
  'Guyana': 'GY',
  'Haiti': 'HT',
  'Heard Insel und McDonald Inseln': 'HM',
  'Vatikanstadt': 'VA',
  'Honduras': 'HN',
  'Hong Kong': 'HK',
  'Ungarn': 'HU',
  'Island': 'IS',
  'Indien': 'IN',
  'Indonesien': 'ID',
  'Iran': 'IR',
  'Irak': 'IQ',
  'Irland': 'IE',
  'Isle of Man': 'IM',
  'Israel': 'IL',
  'Italien': 'IT',
  'Jamaika': 'JM',
  'Japan': 'JP',
  'Jersey': 'JE',
  'Jordan': 'JO',
  'Kasachstan': 'KZ',
  'Kenia': 'KE',
  'Kiribati': 'KI',
  'Nordkorea': 'KP',
  'Südkorea': 'KR',
  'Kuwait': 'KW',
  'Kirgistan': 'KG',
  'Leos': 'LA',
  'Lettland': 'LV',
  'Libanon': 'LB',
  'Lesotho': 'LS',
  'Liberia': 'LR',
  'Libyen': 'LY',
  'Liechtenstein': 'LI',
  'Litauen': 'LT',
  'Luxemburg': 'LU',
  'Macao': 'MO',
  'Mazedonien': 'MK',
  'Madagaskar': 'MG',
  'Malawi': 'MW',
  'Malaysia': 'MY',
  'Malediven': 'MV',
  'Mali': 'ML',
  'Malta': 'MT',
  'Marshall-Inseln': 'MH',
  'Martinique': 'MQ',
  'Mauretanien': 'MR',
  'Mauritius': 'MU',
  'Mayotte': 'YT',
  'Mexiko': 'MX',
  'Mikronesien': 'FM',
  'Moldau': 'MD',
  'Monaco': 'MC',
  'Mongolei': 'MN',
  'Montenegro': 'ME',
  'Montserrat': 'MS',
  'Marokko': 'MA',
  'Mosambik': 'MZ',
  'Myanmar': 'MM',
  'Namibia': 'NA',
  'Nauru': 'NR',
  'Nepal': 'NP',
  'Niederlande': 'NL',
  'Neukaledonien': 'NC',
  'Neuseeland': 'NZ',
  'Nicaragua': 'NI',
  'Niger': 'NE',
  'Nigeria': 'NG',
  'Niue': 'NU',
  'Norfolk Island': 'NF',
  'Nord-Mariana Inseln': 'MP',
  'Norwegen': 'NO',
  'Oman': 'OM',
  'Pakistan': 'PK',
  'Palau': 'PW',
  'Palästina': 'PS',
  'Panama': 'PA',
  'Papua-Neuguinea': 'PG',
  'Paraguay': 'PY',
  'Peru': 'PE',
  'Philippinen': 'PH',
  'Pitcairn': 'PN',
  'Polen': 'PL',
  'Portugal': 'PT',
  'Puerto Rico': 'PR',
  'Katar': 'QA',
  'Réunion': 'RE',
  'Rumänien': 'RO',
  'Russische Föderation': 'RU',
  'Ruanda': 'RW',
  'Saint-Barthélemy': 'BL',
  'St. Helena, Ascension und Tristan da Cunha': 'SH',
  'Saint Kitts und Nevis': 'KN',
  'Saint Lucia': 'LC',
  'Saint Martin': 'MF',
  'Saint Pierre und Miquelon': 'PM',
  'Saint Vincent und die Grenadinen': 'VC',
  'Samoa': 'WS',
  'San Marino': 'SM',
  'Sao Tome und Principe': 'ST',
  'Saudi-Arabien': 'SA',
  'Senegal': 'SN',
  'Serbien': 'RS',
  'Seychellen': 'SC',
  'Sierra Leone': 'SL',
  'Singapur': 'SG',
  'Sint Maarten': 'SX',
  'Slowakei': 'SK',
  'Slowenien': 'SI',
  'Salomon-Inseln': 'SB',
  'Somalia': 'SO',
  'Südafrika': 'ZA',
  'South Georgia und die South Sandwich Inseln': 'GS',
  'Süd-Sudan': 'SS',
  'Spanien': 'ES',
  'Sri Lanka': 'LK',
  'Sudan': 'SD',
  'Suriname': 'SR',
  'Svalbard und Jan Mayen': 'SJ',
  'Swasiland': 'SZ',
  'Schweden': 'SE',
  'Schweiz': 'CH',
  'Syrien': 'SY',
  'Taiwan': 'TW',
  'Tadschikistan': 'TJ',
  'Tansania': 'TZ',
  'Thailand': 'TH',
  'Timor-Leste': 'TL',
  'Togo': 'TG',
  'Tokelau': 'TK',
  'Tonga': 'TO',
  'Trinidad und Tobago': 'TT',
  'Tunesien': 'TN',
  'Türkei': 'TR',
  'Turkmenistan': 'TM',
  'Turks-und Caicos-Inseln': 'TC',
  'Tuvalu': 'TV',
  'Uganda': 'UG',
  'Ukraine': 'UA',
  'Vereinigte Arabische Emirate': 'AE',
  'Vereinigtes Königreich von Großbritannien und Nordirland': 'GB',
  'Vereinigte Staaten von Amerika': 'US',
  'United States Minor Outlying Islands': 'UM',
  'Uruguay': 'UY',
  'Usbekistan': 'UZ',
  'Vanuatu': 'VU',
  'Venezuela': 'VE',
  'Vietnam': 'VN',
  'Virgin Islands (British)': 'VG',
  'Virgin Islands (US)': 'VI',
  'Wallis und Futuna': 'WF',
  'Western Sahara': 'EH',
  'Jemen': 'YE',
  'Sambia': 'ZM',
  'Simbabwe': 'ZW',

  'Vereinigtes Königreich': 'GB',
  'Vereinigte Staaten': 'US',
}

